import Create from './views/Create.vue'
import List from './views/List.vue'
import UpdateGet from './views/UpdateGet.vue'

export const LiquidationRequestRoutes = [
  {
    path: '/liquidation-requests',
    name: 'ListLiquidationRequests',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'liquidation_request:list'
    }
  },
  {
    path: '/liquidation-request',
    name: 'CreateLiquidationRequest',
    component: Create,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'liquidation_request:create'
    }
  },
  {
    path: '/liquidation-request/:id',
    name: 'UpdateLiquidationRequest',
    component: UpdateGet,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'liquidation_request:get'
    }
  },
  {
    path: '/liquidation-request/view/:id',
    name: 'GetLiquidationRequest',
    component: UpdateGet,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'liquidation_request:get'
    }
  }
]
